import { render, staticRenderFns } from "./assign-customers.vue?vue&type=template&id=92c7de26&"
import script from "./assign-customers.vue?vue&type=script&lang=js&"
export * from "./assign-customers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports